import AppAPI from '../../../../api';
import * as socketConstants from '../../../../api/connect/socket/constants';

export const sendChatTypingActivity = status => {
  AppAPI.sendToChatActivityChannel(status, socketConstants.CHAT_ACTIVITY_TYPING_EVENT_NAME);
};
